/**
 * Persona fit label — the ONE definition of Strategic / Supportive / Passive / Low Fit.
 *
 * Bands are the persona rubric's (evasys_persona_workflow_readme_v8 §103), confirmed by Tiago
 * 2026-10-25: Strategic 80–100 (tier A), Supportive 60–79 (B), Passive 40–59 (C), Low Fit below
 * 40 (D). There is no "Moderate" band.
 *
 * Nine components each carried their own copy and they had drifted: six showed "Moderate" for
 * 51–59 and called 50 and below "Passive", three called everything under 60 "Passive", and none
 * showed Low Fit — so the same person read differently on Home, People and their own profile.
 *
 * Returns a translation key (t('strategic') etc.) so each caller keeps its own colours and i18n.
 * A null score is missing data, not Low Fit.
 *
 * (Comment edited 2026-10-25 to release a stuck Cloudflare Pages build; the minifier strips it.)
 */
export function personaFitBand(score) {
  if (score === null || score === undefined || score === '' || Number.isNaN(Number(score))) {
    return null;
  }
  const n = Number(score);
  if (n >= 80) return 'strategic';
  if (n >= 60) return 'supportive';
  if (n >= 40) return 'passive';
  return 'lowFit';
}

/** English labels for the callers that do not translate. */
export const PERSONA_FIT_LABELS = {
  strategic: 'Strategic',
  supportive: 'Supportive',
  passive: 'Passive',
  lowFit: 'Low Fit',
};
